import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaContentBlock {
  constructor() {
    this.data = undefined;
    this._id = undefined;
    this.handlers = undefined;
  }
  async handleButtonClick(e, eventName) {
    if (eventName) {
      this.handlers && this.handlers[eventName](e);
    }
    else {
      this.handlers && this.handlers['handleClick'](e);
    }
  }
  render() {
    var _a, _b, _c, _d;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, { id: this._id ? this._id : '' }, ((_a = this.data) === null || _a === void 0 ? void 0 : _a.styles) && h("style", null, (_b = this.data) === null || _b === void 0 ? void 0 : _b.styles), (_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 :
      _d.map((outerElement, wrapperIndex) => {
        var _a, _b;
        return ((outerElement === null || outerElement === void 0 ? void 0 : outerElement.name) === 'aiba-block' && (h("div", { class: 'aiba-content-block-wrapper aiba-content-block-wrapper-' + wrapperIndex }, (_b = (_a = outerElement === null || outerElement === void 0 ? void 0 : outerElement.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((element, index) => {
          var _a, _b, _c, _d;
          return (h("div", { class: 'aiba-content-block-wrapper--elements-' + index }, (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && (element === null || element === void 0 ? void 0 : element.data.tag) === 'h2' && h("aiba-label", Object.assign({}, element['data'])), (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && (element === null || element === void 0 ? void 0 : element.data.tag) === 'h3' && h("aiba-label", Object.assign({}, element['data'])), (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && (element === null || element === void 0 ? void 0 : element.data.tag) === 'p' && h("aiba-label", Object.assign({}, element['data'])), (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && !['h2', 'h3', 'p'].includes(element === null || element === void 0 ? void 0 : element.data.tag) && h("aiba-label", Object.assign({}, element['data'])), (element === null || element === void 0 ? void 0 : element.name) === 'aiba-button' && (h("aiba-button", Object.assign({}, element['data'], { handleClick: (e) => this.handleButtonClick(e, element['data']['handleClick']) }))), (element === null || element === void 0 ? void 0 : element.name) === 'image' && (h("div", { class: "analysis-icon" }, h("img", Object.assign({}, element === null || element === void 0 ? void 0 : element.data, { src: (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.icon, alt: (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.altText })))), element.name === 'register-wrapper' && (h("div", { class: "register-wrapper" }, (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.elements.map((elem) => {
            if (elem.name === 'aiba-label')
              return h("aiba-label", Object.assign({}, elem['data']));
            if (elem.name === 'br')
              return h("br", null);
            if (elem.name === 'aiba-link' && elem.data._id === 'privacy_statement')
              return (h("aiba-link", Object.assign({}, elem['data'], { clickEvent: (e) => this.handlers && this.handlers.handleOpenPrivacyStatement && this.handlers.handleOpenPrivacyStatement(e) })));
            if (elem.name === 'aiba-link')
              return (h("aiba-link", Object.assign({}, elem['data'], { clickEvent: (e) => this.handlers && this.handlers.signUpHandlerClick && this.handlers.signUpHandlerClick(e) })));
          }))), element.name === 'Privacy-wrapper' && (h("div", { class: "Privacy-wrapper" }, (_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.elements.map((elem) => {
            if (elem.name === 'aiba-label')
              return h("aiba-label", Object.assign({}, elem['data']));
            if (elem.name === 'aiba-link')
              return h("aiba-link", Object.assign({}, elem['data'], { clickEvent: (e) => this.handlers && this.handlers.customLinkClick && this.handlers.customLinkClick(e) }));
          }))), element.name === 'aiba-analysis-steps' && h("aiba-analysis-steps", Object.assign({}, element['data'], { handlers: this === null || this === void 0 ? void 0 : this.handlers }))));
        }))));
      })));
  }
  getCssClassMap() {
    var _a, _b;
    return classNames(`content-block`, ((_a = this.data) === null || _a === void 0 ? void 0 : _a.variant) && `content-block--variant-${(_b = this.data) === null || _b === void 0 ? void 0 : _b.variant} `);
  }
  static get is() { return "aiba-content-block"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-content-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-content-block.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "_id": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-content-block.js.map
